import React from 'react'

export function Label({ label, children }) {
  return (
    <label className="label" style={{ marginTop: 20 }}>
      {label}
      {children}
    </label>
  )
}
